import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type Props = {
  enabled?: boolean;
  reservationId?: string;
};
function useFetchReservationPayments({reservationId}: Props = {}) {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.reservationPayments, reservationId],
    queryFn: () => API.payments.getReservationPayments(reservationId ?? ''),
    enabled: Boolean(reservationId),
  });
}

export {useFetchReservationPayments};
